// Sourced from Amazon string translator:
// https://tiny.amazon.com/12juqx7ta/tranamazsearstri
// Set: KatalComponents
// Id: date-picker-calendar-button-aria-label
const strings = {
  'en-US': 'Calendar',
  'en-CA': 'Calendar',
  'ja-JP': 'ã‚«ãƒ¬ãƒ³ãƒ€ãƒ¼',
  'fr-FR': 'Calendrier',
  'es-ES': 'Calendario',
  'en-GB': 'Calendar',
  'it-IT': 'Calendario',
  'pt-BR': 'CalendÃ¡rio',
  'de-DE': 'Kalender',
  'en-IN': 'Calendar',
  'es-MX': 'Calendario',
  'tr-TR': 'Takvim',
  'zh-CN': 'æ—¥åŽ†',
  'ko-KR': 'ë‹¬ë ¥',
};
export default strings;
